import { employersDirectoryList } from "./employers-directory-list/employers-directory-list.module"
import { employersDirectoryMain } from './employers-directory-main/employers-directory-main.module'
import { employersDirectoryAdd } from "./employers-directory-add/employers-directory-add.module"
import { employersDirectoryEdit } from "./employers-directory-edit/employers-directory-edit.module"
import { employersDirectoryView } from "./employers-directory-view/employers-directory-view.module"
import { employersDirectoryManageIndustryMain } from "./employers-directory-manageIndustry-main/employers-directory-manageIndustry-main.module"
import { EmployersDirectoryService } from "./employers-directory.service"

export const employerDirectory = angular
.module("components.employers-directory-main",[
     employersDirectoryList,
     employersDirectoryMain,
     employersDirectoryAdd,
     employersDirectoryEdit,
     employersDirectoryView,
     employersDirectoryManageIndustryMain
])
.service("EmployersDirectoryService", EmployersDirectoryService).name;



// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory.module.js